import ProgressBar from "../../components/ProgressBar";

const Layout = ({children, enableProgress, progressStatus}) => {
  return (
    <>
       <div className="flex min-h-full flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8">
        {/* <div className="w-full  dark:border-strokedark xl:w-1/2 tranform-center"> */}
        {enableProgress && <ProgressBar progressStatus={progressStatus} />}
          {/* <div className="w-full p-4 sm:p-12.5 xl:p-17.5 items-center"> */}
            {children}
          {/* </div> */}
        {/* </div> */}
      </div>
    </>
  );
};

export default Layout;
